<template>
    <div>
        <b-form v-on:submit.prevent="mlsEntryUpload" class="text-left">
            <b-form-group id="mls-input-group-status" label="Status:" label-for="mls-upload-status">
                <b-form-select id="mls-upload-status" v-model="MLSuploadForm.status" :options="mlsStatus"></b-form-select>
            </b-form-group>
            <b-form-group id="mls-input-group-list-price" label="List Price:" label-for="mls-upload-list-price">
                <b-form-input v-model="MLSuploadForm.listPrice" id="mls-upload-list-price" type="text" placeholder="List Price"></b-form-input>
            </b-form-group>
            <b-form-group id="mls-input-group-list-price" label="Sold Price:" label-for="mls-upload-sold-price">
                <b-form-input v-model="MLSuploadForm.soldPrice" id="mls-upload-sold-price" type="text" placeholder="Sold Price"></b-form-input>
            </b-form-group>
            <b-form-group id="input-group-price-backup" label="Price Backup:" label-for="upload-price-backup">
                <b-form-select id="upload-price-backup" v-model="MLSuploadForm.priceBackup" :options="priceBackupOption"></b-form-select>
            </b-form-group>
            <label for="upload-list-date" style="font-size: 1.8rem;">List Price Date</label>
            <b-form-datepicker id="mls-upload-list-price-date" v-model="MLSuploadForm.listPriceDate" reset-button class="mb-2"></b-form-datepicker>
            <label for="upload-list-date" style="font-size: 1.8rem;">Sold Date</label>
            <b-form-datepicker id="mls-upload-sold-date" v-model="MLSuploadForm.soldDate" reset-button class="mb-2"></b-form-datepicker>
            <label for="upload-backup-file" style="font-size: 1.8rem;">Back-up File:</label>
            <b-form-group id="mls-input-group-5">
                <b-form-file
                    v-model="MLSuploadForm.floorPlan"
                    :state="Boolean(MLSuploadForm.floorPlan)"
                    placeholder="Choose a file or drop it here..."
                    drop-placeholder="Drop file here..."
                    ></b-form-file>
            </b-form-group>
            <b-form-group style="margin-top: 40px;" id="mls-input-group-backup-text" label="Back-up Text:" label-for="mls-upload-backup-text">
                <b-form-input v-model="MLSuploadForm.backupText" id="mls-upload-backup-text" type="text" placeholder="Backup Text"></b-form-input>
            </b-form-group>
            <b-form-group id="mls-input-group-buyer-incentives" label="Buyer Incentives:" label-for="mls-upload-buyer-incentives">
                <b-form-input v-model="MLSuploadForm.buyerIncentives" id="mls-upload-buyer-incentives" type="text" placeholder="Buyer Incentives"></b-form-input>
            </b-form-group>
            <b-form-group id="mls-input-group-realtor-incentives" label="Realtor Incentives:" label-for="mls-upload-realtor-incentives">
                <b-form-input v-model="MLSuploadForm.realtorIncentives" id="mls-upload-realtor-incentives" type="text" placeholder="Realtor Incentives"></b-form-input>
            </b-form-group>
            <b-button type="submit" variant="primary">Submit</b-button>
        </b-form>
    </div>
</template>

<script>
import { BACKEND_URL } from '../../variables.js'
    export default {
        props:{
            cidSelected: null,
            pageName: null
        },
        data(){
            return {
                prefillFile: {fileExist: false},
                uploadForm: {
                    planName: '',
                    fp: [],
                    orientation: 11105,
                    unit: '',
                    bed: '',
                    bath: '',
                    unitSize: '',
                    listPrice: '',
                    pr: 11107,
                    locker: '',
                    gst: '',
                    buyerIncentives: '',
                    realtorIncentives: '',
                    // status: 8197,
                    soldDate: null,
                    listDate: null,
                    listPriceDate: null,
                    fl: 11106,
                    owner: '',
                    purchaser: '',
                    pid: '',
                },
                formDisabled: {
                    planName: false,
                    fp: false,
                    orientation: false,
                    unit: false,
                    bed: false,
                    bath: false,
                    unitSize: false,
                    listPrice: false,
                    pr: false,
                    locker: false,
                    gst: false,
                    buyerIncentives: false,
                    realtorIncentives: false,
                    // status: false,
                    soldDate: false,
                    listDate: false,
                    listPriceDate: false,
                    fl: false,
                    owner: false,
                    purchaser: false,
                    pid: false,
                },
                mlsOrientation: [
                    {text: 'East', value: 11033},
                    {text: 'North', value: 11030},
                    {text: 'North East', value: 11035},
                    {text: 'North West', value: 11034},
                    {text: 'South', value: 11032},
                    {text: 'South East', value: 11037},
                    {text: 'South West', value: 11036},
                    {text: 'West', value: 11031},
                ],
                mlsFP: [],
                mlsParking: [],
                mlsFloorLevel: [],
                mlsStatus: [{text: 'Active', value: 8197}, {text: 'Sold', value: 8198}],
                MLSuploadForm: {
                    listPrice: '',
                    listPriceDate: null,
                    buyerIncentives: '',
                    realtorIncentives: '',
                    backupText: '',
                    files: null,
                    priceBackup: '',
                    soldDate: null
                },
                mlsStatus: [{text: '', value: 11482}, {text: 'Active', value: 8197}, {text: 'Sold', value: 8198}],
                priceBackupOption: [
                    {text: '', value: ''},
                    {text: 'Verified', value: 'Verified'},
                    {text: 'Semi-Verified', value: 'Semi-Verified'},
                    {text: 'Educated Estimated', value: 'Educated Estimated'}
                ],
            }
        },
        methods:{
            useUploadAction() {
              if(this.pageName === 'unitmix')
                this.mlsEntryUpload()

              if(this.pageName === 'unitmixreport')
                this.createMlsEntry()
            },
            createMlsEntry() {
              let formData = new FormData();
                formData.append('planName', this.uploadForm.planName);
                let fpArray = [];
                this.uploadForm.fp.forEach(
                    element => fpArray.push(element.value)
                );
                formData.append('fp', fpArray);
                formData.append('pr', this.uploadForm.pr);
                formData.append('fl', this.uploadForm.fl);
                formData.append('orientation', this.uploadForm.orientation);
                formData.append('unit', this.uploadForm.unit);
                formData.append('bed', this.uploadForm.bed);
                formData.append('bath', this.uploadForm.bath);
                formData.append('unitSize', this.uploadForm.unitSize);
                formData.append('listPrice', this.uploadForm.listPrice);
                formData.append('parking', this.uploadForm.parking);
                formData.append('locker', this.uploadForm.locker);
                formData.append('gst', this.uploadForm.gst);
                formData.append('buyerIncentives', this.uploadForm.buyerIncentives);
                formData.append('realtorIncentives', this.uploadForm.realtorIncentives);
                formData.append('status', this.uploadForm.status);
                formData.append('soldPrice', this.uploadForm.soldPrice);
                formData.append('files', this.uploadForm.floorPlan);
                formData.append('soldDate', this.uploadForm.soldDate);
                formData.append('listDate', this.uploadForm.listDate);
                formData.append('listPriceDate', this.uploadForm.listPriceDate);
                formData.append('fid', this.$route.query.fid);
                formData.append('cid', this.$route.query.cid);
                formData.append('owner', this.uploadForm.owner);
                formData.append('purchaser', this.$route.query.purchaser);
                formData.append('pid', this.uploadForm.pid);
                var vm = this;
                $.ajax({
					type: 'POST',
					url: BACKEND_URL + 'api/presale_mls_entry_creation',
                    data: formData,
                    processData: false,
                    contentType: false,
				}).done(function(response) {
          console.log(response)
                    //window.location.href = "/type?project="+vm.$route.query.project+"&fid="+vm.$route.query.fid+"&sid="+vm.$route.query.sid+"&uid="+vm.$route.query.uid + '&tab=unit';
                });
            },
            mlsEntryUpload() {
                var vm = this;
                let formData = new FormData();
                formData.append('status', vm.MLSuploadForm.status);
                formData.append('listPrice', vm.MLSuploadForm.listPrice);
                formData.append('listPriceDate', vm.MLSuploadForm.listPriceDate);
                formData.append('files', vm.MLSuploadForm.floorPlan);
                formData.append('backupText', vm.MLSuploadForm.backupText);
                formData.append('buyerIncentives', vm.MLSuploadForm.buyerIncentives);
                formData.append('realtorIncentives', vm.MLSuploadForm.realtorIncentives);
                formData.append('priceBackup', vm.MLSuploadForm.priceBackup);
                formData.append('cid', vm.cidSelected);
                formData.append('soldDate', vm.MLSuploadForm.soldDate);
                formData.append('soldPrice', vm.MLSuploadForm.soldPrice);
                formData.append('uid', vm.$route.query.uid);
                console.log(formData)
                $.ajax({
                    type: 'POST',
                    url: BACKEND_URL + 'api/presale_mls_entry_add_entry',
                    data: formData,
                    processData: false,
                    contentType: false,
                }).done(function(response) {
                     location.reload();
                });
            },
        },
        mounted: function() {
            const vm = this;
            $.get({
                url: BACKEND_URL + 'api/get_fp_specs',
            }, (data, status) => {
                if (status === 'success') {
                    vm.mlsFP = data.fp_specs;
                    vm.mlsParking = data.parking;
                    vm.mlsFloorLevel = data.floor_level;
                }
            });

            $.get({
                url: BACKEND_URL + 'api/get_last_mls_by_cid?cid=' + this.cidSelected,
            }, (data, status) => {
                if (status === 'success') {
                    vm.uploadForm.planName = data.plan_name;
                    vm.uploadForm.fp = data.fp;
                    vm.uploadForm.orientation = data.orientation;
                    vm.uploadForm.unit = data.address;
                    vm.uploadForm.bed = data.beds;
                    vm.uploadForm.bath = data.baths;
                    vm.uploadForm.unitSize = data.unit_size;
                    vm.uploadForm.listPrice = data.list_price;
                    vm.uploadForm.pr = data.parking_ref;
                    vm.uploadForm.locker = data.locker;
                    vm.uploadForm.gst = data.gst;
                    vm.uploadForm.buyerIncentives = data.buyer;
                    vm.uploadForm.realtorIncentives = data.realtor;
                    vm.uploadForm.status = data.status;
                    vm.uploadForm.soldDate = data.sold_date;
                    vm.uploadForm.listDate = data.list_date;
                    vm.uploadForm.listPriceDate = data.list_price_date;
                    vm.uploadForm.fl = data.fl;
                    vm.uploadForm.owner = data.owner;
                    vm.uploadForm.pid = data.pid;
                    vm.uploadForm.purchaser = data.purchaser;
                    if (data.floor_plan_file) {
                        vm.prefillFile.link = data.floor_plan_file.link;
                        vm.prefillFile.title = data.floor_plan_file.title;
                        vm.prefillFile.fileExist = true;
                    }
                    vm.formDisabled.planName = data.plan_name ? true : false;
                    vm.formDisabled.fp = data.fp.length > 0  ? true : false;
                    vm.formDisabled.orientation = data.orientation  ? true : false;
                    vm.formDisabled.unit = data.address  ? true : false;
                    vm.formDisabled.bed = data.beds  ? true : false;
                    vm.formDisabled.bath = data.baths  ? true : false;
                    vm.formDisabled.unitSize = data.unit_size  ? true : false;
                    vm.formDisabled.listPrice = data.list_price  ? true : false;
                    vm.formDisabled.pr = data.parking_ref  ? true : false;
                    vm.formDisabled.locker = data.locker  ? true : false;
                    vm.formDisabled.gst = data.gst  ? true : false;
                    vm.formDisabled.buyerIncentives = data.buyer  ? true : false;
                    vm.formDisabled.realtorIncentives = data.realtor  ? true : false;
                    // vm.formDisabled.status = data.status  ? true : false;
                    // vm.formDisabled.soldDate = data.sold_date  ? true : false;
                    vm.formDisabled.soldDate = false;
                    vm.formDisabled.listDate = data.list_date  ? true : false;
                    vm.formDisabled.listPriceDate = data.list_price_date  ? true : false;
                    vm.formDisabled.fl = data.fl  ? true : false;
                }
            });
        },
    }

</script>

<style lang="scss" scoped>

</style>
